export const estoqueItems = [
    { category: "Estoque", key: "ajustesEstoque", name: "Ajustes de estoque" },
    {
      category: "Estoque",
      key: "extratoEstoque",
      name: "Extrato de estoque",
    },
  ];
  
  